export default {
    '/': 'HomePage',
    '/archmirror': 'ArchMirrorPage',
    '/about': 'AboutPage',
    '/lightning': 'LightningPage',
    '/start-screen': 'StartScreenPage',
}